import { useMemo } from "react";
import { useMatch, useParams } from "react-router-dom";
import { SCREENS } from "../routes/screens";
import { useMediaQueryBreakpoint } from "./useMediaQuery";

export const useIsTopNavTranslucent = () => {
  const { isMobile } = useMediaQueryBreakpoint();
  const { username } = useParams<{ username: string }>();
  const matchProfileScreenPattern = useMatch(SCREENS.PROFILE_SCREEN);

  // The Top Nav is only translucent when the user is on an artist profile page (mobile view)
  const isTopNavTranslucent = useMemo(() => {
    return isMobile && Boolean(username) && Boolean(matchProfileScreenPattern);
  }, [isMobile, username, matchProfileScreenPattern]);

  return { isTopNavTranslucent };
};
